import { createSlice } from "@reduxjs/toolkit";
import { EquityBasketSliceInterface } from "interfaces/EquityBasket";

const initialState: EquityBasketSliceInterface = {
  selectedBasket: null,
  equityBasketList: 0,
};

const equityBasketSlice = createSlice({
  name: "equityBasket",
  initialState,
  reducers: {
    SET_SELECTED_BASKET: (state, action) => {
      state.selectedBasket = action.payload;
    },
    SET_EQUITY_BASKET_LIST: (state, action) => {
      state.equityBasketList = action.payload;
    },
  },
});

export const { SET_SELECTED_BASKET, SET_EQUITY_BASKET_LIST } =
  equityBasketSlice.actions;

export default equityBasketSlice.reducer;
